import { useEffect } from "react";
import axios from "axios";
import isE2e from "@/helpers/isE2e";

// Set to 2 seconds for e2e tests, so that the tests don't take too long
const INTERVAL = isE2e ? 2 * 1000 : 60 * 1000;

const useReloadBundle = () => {
  useEffect(() => {
    const checkAndRefresh = async () => {
      const response = await axios.get("/version.txt");
      const latestVersion = response.data.replace(/\n/g, "");
      const shouldRefresh = latestVersion !== __APP_VERSION__;
      if (shouldRefresh) window.location.reload();
    };
    const interval = setInterval(checkAndRefresh, INTERVAL);
    return () => clearInterval(interval);
  }, []);
};

export default useReloadBundle;
